module.exports = "<textarea #textarea\n          [(ngModel)]=\"innerValue\"\n          (ngModelChange)=\"updateNumbers()\"\n          [attr.id]=\"id\"\n          (scroll)=\"updateNumbers()\"\n          [placeholder]=\"placeholder\"\n></textarea>\n<div #lineNumbers class=\"textarea-line-numbers\">\n    <div class=\"textarea-number\" *ngFor=\"let i of lineCount | range\">{{ i + 1 }}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-textarea/ui-textarea.html
// module id = 1120
// module chunks = 3